/**
 * 訂單相關常數
 * 訂單狀態、付款狀態、出貨狀態，前後端共用
 */
/** 訂單狀態（成立／作廢） */
export const ORDER_STATUS = {
    CONFIRMED: '成立',
    VOIDED: '作廢',
};
/** 付款狀態（已付款／待付款／未付款） */
export const PAYMENT_STATUS = {
    PAID: '已付款',
    UNPAID: '待付款',
    NOT_PAID: '未付款',
};
/** 出貨狀態（由出貨單推導的顯示文字） */
export const SHIPPING_STATUS = {
    /** 待出貨（尚未建立出貨單或尚未出庫） */
    PENDING: '待出貨',
    /** 待處理（出貨單 pending） */
    PENDING_PROCESSING: '待處理',
    /** 處理中（出貨單 processing） */
    PROCESSING: '處理中',
    /** 已出貨（出貨單 shipped） */
    SHIPPED: '已出貨',
    /** 已送達（出貨單 delivered，待取貨） */
    DELIVERED: '已送達',
    /** 已取貨（出貨單 picked_up） */
    PICKED_UP: '已取貨',
    /** 已退回（出貨單 returned） */
    RETURNED: '已退回',
};
